// extracted by mini-css-extract-plugin
module.exports = {"productList":"productList_productList__XNmVZ","fadeIn":"productList_fadeIn__C_Rsz","feedback":"productList_feedback__4fd9O","closeIcon":"productList_closeIcon__6g4FM"};